import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { GenericHttpService } from "./../../../shared/services/generic-http.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class HighlightService {
  constructor(private generic: GenericHttpService) {}
  Allvalues;
  apiUrl = environment.gateWayHost;
  GetPercentValue(url, params?) {
    //var Allvalues;
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: `${this.apiUrl}${url}`,
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
